<script lang="ts">
    import ImageSkeleton from "@components/skeletons/ImageSkeleton.svelte";

    export let square = false;
    export let imageRatio: number = 1 / 1;
</script>

<div
    class="gw-ig-post-card-skeleton"
    class:gw-ig-post-card-skeleton--square={square}
>
    <div class="gw-ig-post-card-skeleton__content">
        <ImageSkeleton ratio={imageRatio} />
    </div>
</div>

<style>
    .gw-ig-post-card-skeleton {
        position: relative;
        width: 100%;
        height: 100%;
        cursor: pointer;
    }

    .gw-ig-post-card-skeleton--square {
        height: unset;
    }

    .gw-ig-post-card-skeleton--square::after {
        content: "";
        display: block;
        padding-bottom: 100%;
    }

    .gw-ig-post-card-skeleton--square .gw-ig-post-card-skeleton__content {
        position: absolute;
        width: 100%;
        height: 100%;
    }
    .gw-ig-post-card-skeleton__content
        :global(.gw-ig-post-card-skeleton__image__icon) {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100px;
        height: 100px;
        transform: translateX(-50%) translateY(-50%);
        color: #ccc;
    }
</style>
